let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6KBLY")).then(() => parcelRequire('keQOQ'));